<template>
	<div 
		v-for="upload in uploads"
		:key="upload.id"
		:class="['tileWrap', upload.status]"
	>
		<div 
			v-if="uploads.length > 0 && upload.status !== 'done' "			
			:class="['itemTile', upload.status]"
		>
			<div class="icon">
				<div class="documentIcon icon-pdf" />
			</div>
			<div class="fileInfo">
				<span class="name">{{ upload.file.name }}</span>
				<span class="status"><span class="statusIcon" />{{ upload.message }}</span>
			</div>
			<a class="deleteTile" @click="cancelUpload(upload)" />
		</div>
	</div>
	<div
		v-for="upload in existingUploads"			
		:key="upload.id"
		:class="['tileWrap', upload.status]"
	>
		<div 
			v-if="upload.file.name !== '' && upload.status !== 'done' " 
			:class="['itemTile', upload.status]"
		>
			<div class="icon">
				<div class="documentIcon icon-pdf" />
			</div>
			<div class="fileInfo">
				<span class="name">{{ upload.file.name }}</span>
				<span class="status"><span class="statusIcon" />{{ upload.message }}</span>
			</div>
			<a class="deleteTile" @click="cancelUpload(upload)" />
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {	
	computed: {
		...mapState([`uploads`, `uploadStatusEnum`, `uploadTypeEnum`, `existingUploads`, `acceptedExtensions`, `maxFileSize`]),
		...mapState(`API`, [`notarizationId`]),
	},
	methods: {
		cancelUpload: function (upload) {
			this.updateUpload({
				id: upload.id,
				type: upload.type,
				status: this.uploadStatusEnum.CANCEL,
				message: `Removing item...`,
			});
			
			if (upload.file.size == 0
				|| upload.file.size > this.maxFileSize
				|| upload.status === `error`
				|| !this.acceptedExtensions.has(upload.file.name)
			) {
				this.clearUploads(upload);
			}
		},
		...mapMutations([`clearUploads`, `updateUpload`]),
		...mapActions([`handleUploadPromise`]),
	},
};
</script>